"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.slice.js");
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'WlButton',
  props: {
    /* 显示控制 */
    show: {
      type: [Boolean, Function],
      default: true
    },
    /* 渲染 */
    render: {
      type: [Boolean, Function],
      default: true
    },
    /* 加载 */
    loading: {
      type: [Boolean, Function],
      default: false
    },
    /* 禁用 */
    disabled: {
      type: [Boolean, Function],
      default: false
    },
    /* 如果上边的数据类型是方法的时候，这里做的参数作为回调函数的参数，顺序根据数组的下标 */
    params: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // loading: false,
      button: {
        size: 'mini',
        type: 'primary',
        show: true,
        render: true,
        loading: false,
        disabled: false
      },
      btnLoading: false
    };
  },
  computed: {
    bindTooltip: function bindTooltip() {
      return Object.assign({
        placement: 'top'
      }, this.$attrs.tooltip);
    },
    isTooltip: function isTooltip() {
      return this.$$isEmpty(this.$attrs.tooltip);
    },
    isShow: function isShow() {
      return this.anyToBoolean('show', true, this.params) && this.$$isPermi(this.button);
    },
    isRender: function isRender() {
      return this.anyToBoolean('render', true, this.params) && this.$$isPermi(this.button);
    },
    isLoading: function isLoading() {
      return this.anyToBoolean('loading', false, this.params);
    },
    isDisabled: function isDisabled() {
      return this.anyToBoolean('disabled', false, this.params);
    }
  },
  watch: {
    show: {
      handler: function handler(nv) {
        // console.log('this.button.show', nv)
        this.button.show = nv;
      },
      deep: true
    },
    render: {
      handler: function handler(nv) {
        // console.log('this.button.render', nv)
        this.button.render = nv;
      },
      deep: true
    },
    loading: {
      handler: function handler(nv) {
        // console.log('this.button.loading', nv)
        this.button.loading = nv;
      },
      deep: true
    },
    disabled: {
      handler: function handler(nv) {
        // console.log('this.button.disabled', nv)
        this.button.disabled = nv;
      },
      deep: true
    }
  },
  methods: {
    // 鼠标按钮被按下时发生
    mousedown: function mousedown(e) {
      this.$emit('mousedown', e, this.button);
    },
    // 鼠标按键被松开时发生
    mouseup: function mouseup(e) {
      this.$emit('mouseup', e, this.button);
    },
    /** 获取布尔值
     * @description 获取布尔值，主要针对方法，如果输入值是方法，那么就执行该方法并将返回值计算布尔值
     * @param { * } data 需要转换的数据
     * @param { Boolean } default 默认值
     * @param { Array } params 给回调方法作为参数的数据
     * @return { Boolean } 返回
     */
    anyToBoolean: function anyToBoolean() {
      var a = Object.assign(this.button, this.$attrs);
      var b = arguments[0];
      var c = arguments[1];
      var d = this.$$anyInArray(arguments[2]);
      var e = function e(f) {
        return Boolean(typeof f === 'function' ? f.apply(void 0, (0, _toConsumableArray2.default)(d).concat([a])) : f !== null && f !== void 0 ? f : c);
      };
      var s = 'is' + b[0].toLocaleUpperCase() + b.slice(1);
      if (c) a[b] = e(a[s]) && e(this[b]);else a[b] = e(a[s]) || e(this[b]);
      return a[b];
    } /* data, default, params */
  },
  created: function created() {}
};